module.exports = __webpack_public_path__ + "static/img/aepic-25.7a4afd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-25.jpg
// module id = aXCW
// module chunks = 51